import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

 private companyNameSource = new BehaviorSubject<string | null>(
    sessionStorage.getItem('companyName')
  );

  companyName$ = this.companyNameSource.asObservable();

  setCompanyName(name: string) {
    sessionStorage.setItem('companyName', name);
    this.companyNameSource.next(name);
  }
}
